<template>
  <div class="personalcenter container">
    <div class="leftcon bgfff tc">
      <div class="basicbox demo-avatar demo-basic">
        <el-avatar :size="100" :src="getImage(user.userimage)"></el-avatar>
        <div class="sub-title">{{ user.username }}</div>
      </div>
      <el-menu
        @open="handleOpen"
        @close="handleClose">
        <template v-for="item in tabsArr">
          <el-submenu :index="item.name" :key="item.id" v-if="item.children && item.children.length > 0">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item :index=items.name v-for="(items, index) in item.children" :key="index" @click="orderchange(items.tabid)">
              <i :class="items.icon"></i><span slot="title">{{ items.name }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item :index="item.name" :key="item.id" @click="orderchange(item.tabid)"  v-else>
            <i :class="item.icon"></i><span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="rightcon bgfff">
      <!-- 活动报名-->
      <div v-show="tabshowIndex === 0">
        <userappointment/>
      </div>
      <!-- 场馆预订-->
      <div v-show="tabshowIndex === 1">
        <uservenue/>
      </div>
      <!-- 我的收藏-->
      <div class="p20" v-show="tabshowIndex === 2">
        <usercollect/>
      </div>
      <!-- 联系人管理-->
      <div v-show="tabshowIndex === 3">
        <usercontact/>
      </div>
      <!-- 积分兑换-->
      <div v-show="tabshowIndex === 4">
        <usercreditorder/>
      </div>
      <!-- 当前积分-->
      <div v-show="tabshowIndex === 5">
        <usercredit/>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/validate'
import nodata from '@/components/nodata/index'
import userappointment from './userappointment'
import uservenue from './uservenue'
import usercollect from './usercollect'
import usercontact from './usercontact'
import usercreditorder from './usercreditorder'
import usercredit from './usercredit'
export default {
  name: 'personalcenter',
  meta: {
    showHeader: true
  },
  components: {
    nodata,
    userappointment,
    uservenue,
    usercollect,
    usercontact,
    usercreditorder,
    usercredit
  },
  data () {
    return {
      tabsArr: [
        {
          'id': 1,
          'name': '我的订单',
          'icon': 'el-icon-goods',
          'children': [{
            'tabid': 0, 'icon': 'el-icon-umbrella', 'name': '活动预约'
          }, {
            'tabid': 1, 'icon': 'el-icon-office-building', 'name': '场馆预订'
          }]
        },
        {
          'id': 2,
          'icon': 'el-icon-star-off',
          'name': '我的收藏',
          'tabid': 2,
          'children': []
        },
        {
          'id': 3,
          'icon': 'el-icon-user',
          'name': '联系人管理',
          'tabid': 3,
          'children': []
        },
        {
          'id': 4,
          'icon': 'el-icon-shopping-cart-1',
          'name': '我的积分',
          'tabid': 4,
          'children': [{
            'tabid': 4, 'icon': 'el-icon-present', 'name': '积分兑换'
          }, {
            'tabid': 5, 'icon': 'el-icon-price-tag', 'name': '当前积分'
          }]
        }
      ],
      tabshowIndex: 0,
      collapseIndex: ['1'],
      user: {
        userimage: '',
        phone: this.$cookie.get('wlymobilephone'),
        username: ''
      }
    }
  },
  mounted () {
    this.user.userimage = this.$cookie.get('wlyuserimg')
    if (this.$cookie.get('wlyusername') !== undefined || this.$cookie.get('wlyusername') !== '') {
      this.user.username = this.$cookie.get('wlyusername')
    } else {
      this.user.username = this.$cookie.get('wlymobilephone')
    }
  },
  methods: {
    getImage (val) {
      if (val === 'undefined' || val === '') {
        return require('@/assets/common/icon/icon-default-avatar.png')
      } else {
        return val
      }
    },
    getTime (val) {
      let hhmm = timeFormat(val, 'yymmddhhmm').split(' ')[1]
      if (hhmm === '00:00') {
        return timeFormat(val, 'yymmdd')
      } else {
        return timeFormat(val, 'yymmddhhmm')
      }
    },
    handleOpen (val) {
      // console.log(val)
    },
    handleClose () {
    },
    orderchange (val) {
      // console.log(val)
      this.tabshowIndex = val
    },
    handleChange (val) {
      // console.log(val)
    },
    tabhandleClick () {
    }
  }
}
</script>

<style lang="scss" scoped>
.personalcenter{
  display: flex;
  padding: 30px 0 0;
  margin-bottom: 50px;
  .leftcon,
  .rightcon{
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.01);
  }
  .leftcon{
    width: 260px;
    padding: 40px 0;
    .basicbox{
      padding: 0 0 20px;
      margin: 0 0 20px;
      .el-avatar{
        background: url('~@/assets/common/icon/icon-default-avatar.png') no-repeat;
        background-size: 100% 100%;
      }
      .sub-title{
        margin: 16px 0 0;
      }
    }
    .el-menu{
      border-right: none;
      padding: 0 20px;
      text-align: left;
    }
    /deep/ .el-submenu.is-active{
      i{
        color: inherit;
      }
    }
  }
  .rightcon{
    margin: 0 0 0 20px;
    flex: 1;
    min-width: 0;
    .w5{
      padding: 20px;
      /deep/ .el-tabs{
        .el-tabs__nav-wrap::after{
          height: 1px;
          background: #eee;
        }
        .el-tabs__nav{
          width: 100%;
          .el-tabs__item{
            width: 20%;
            height: 50px;
            line-height: 50px;
            text-align: center;
          }
        }
      }
      &.venue{
        /deep/ .el-tabs{
          .el-tabs__nav{
            .el-tabs__item{
              width: 14%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/index.vue